
import React from 'react';
import { Button } from "@/components/ui/button";
import { Save, XCircle } from "lucide-react";

interface JobOverviewActionsProps {
  canEdit: boolean;
  isEditing: boolean;
  isUpdating: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const JobOverviewActions: React.FC<JobOverviewActionsProps> = ({
  canEdit,
  isEditing,
  isUpdating,
  onSave,
  onCancel
}) => {
  if (!canEdit || !isEditing) {
    return null;
  }

  return (
    <div className="flex justify-end gap-2 border-t pt-4">
      <Button variant="outline" onClick={onCancel} disabled={isUpdating}>
        <XCircle className="h-4 w-4 mr-2"/>
        Cancel
      </Button>
      <Button onClick={onSave} disabled={isUpdating}>
        <Save className="h-4 w-4 mr-2"/>
        {isUpdating ? 'Saving...' : 'Save Changes'}
      </Button>
    </div>
  );
};
